import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const DanalPayment = () => {
  return <DataFormSubmitPage />;
};

export default DanalPayment;
